import { Button, Card, Flex, IconSvg, Text } from '@/lib/v2/components';
import { CloseIcon } from '@/lib/v2/icons/outline';
import { TextSmsIcon } from '@/lib/v2/icons/solid';

interface TemplateCardProps {
  templateName: string;
  onDelete: () => void;
}

const TemplateCard = ({ templateName, onDelete }: TemplateCardProps) => {
  return (
    <Card className="!py-2 !pl-4 !pr-2">
      <Flex noGrow alignment="spaceBetween" itemAlignment="center">
        <Flex noGrow withGap alignment="start" gapSize="small" itemAlignment="center">
          <IconSvg height="16" svgComponent={<TextSmsIcon />} width="16" />
          <Text className="-mt-0.5" fontWeight="medium" variant="text">
            {templateName ?? '-'}
          </Text>
        </Flex>
        <Flex noGrow withGap alignment="end" gapSize="small" itemAlignment="center">
          <Button link secondary size="small" onClick={onDelete}>
            <IconSvg fillColor="gray-dark" svgComponent={<CloseIcon />} />
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
};

export default TemplateCard;
